/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import _ from 'lodash';

import { Fragment } from 'react';
import { withFormik, FormikProps } from 'formik';
import * as yup from 'yup';
import { compose } from 'recompose';

import { connect } from '../../../../../utils/redux';

import { updateSupplierAgentReq } from './store/actions';
import { Action } from '../../../../../store/types';
import * as validatinShemas from '../../../../../utils/validatinShemas';

import {} from './store/selectors';

import PrimaryBtn from '../../../../common/buttons/PrimaryBtn';
import OutlineBtn from '../../../../common/buttons/OutlineBtn';
import form from '../../../../common/form';
import page from '../../../../common/page';
import routes from '../../../../../routes';

import { Link } from 'react-router-dom';
import { ISupplierAgent } from './store/types';
import { Colors } from '../../../../../styles/styles';

interface FormValues {
  name: string;
  phone: string;
  email: string;
}

interface OtherProps {
  updateSupplierAgentReq: Action<{}>;
  supplierAgent: ISupplierAgent;
  ownerId: string;
}

interface FormProps {
  initialEmail?: string;
}

jsx;

const EditForm = ({
  errors,
  touched,
  values,
  setFieldValue,
  ownerId,
  supplierAgent,
}: OtherProps & FormikProps<FormValues>) => {
  const { FormRow, FormField, FormRadio, FormError, FormBlock, FieldsSet, ActionsRow, Form, FieldsArea } = form;
  const { Page, Breadcrumbs, PageHeader } = page;

  return (
    <Fragment>
      <PageHeader title="Edit agent">
        <Breadcrumbs
          path={[
            { title: 'Suppliers', link: routes.Suppliers },
            { title: 'Agents', link: routes.SupplierAgents.replace(':owner_id', ownerId) },
            {
              title: 'Edit agent',
              link: routes.SupplierAgentEdit.replace(':owner_id', ownerId).replace(':id', `${supplierAgent.id}`),
            },
          ]}
        />
      </PageHeader>
      <Page>
        <Form>
          <div>
            <FieldsArea>
              <FormBlock>
                <FieldsSet>
                  <FormRow>
                    <label htmlFor="name">Name</label>
                    <FormField name="name" placeholder="name" />
                    <FormError name="name" errors={errors} touched={touched} />
                  </FormRow>

                  <FormRow>
                    <label htmlFor="email">Email</label>
                    <FormField name="email" placeholder="email" />
                    <FormError name="email" errors={errors} touched={touched} />
                  </FormRow>

                  <FormRow>
                    <label htmlFor="phone">Phone</label>
                    <FormField name="phone" placeholder="+1234567890" />
                    <FormError name="phone" errors={errors} touched={touched} />
                    <p css={style.description}>
                      Please add phone number in international format. Use only '+' and numbers.
                    </p>
                  </FormRow>
                </FieldsSet>
              </FormBlock>
            </FieldsArea>

            <ActionsRow>
              <Link to={routes.SupplierAgents.replace(':owner_id', ownerId)}>
                <OutlineBtn title="Cancel" isWide={false} />
              </Link>
              <PrimaryBtn title="Update agent" isWide={false} />
            </ActionsRow>
          </div>
        </Form>
      </Page>
    </Fragment>
  );
};

export const exchangeFormic = withFormik<FormProps & OtherProps, FormValues>({
  mapPropsToValues: ({ supplierAgent }) => {
    const map = {
      name: '',
      phone: '',
      email: '',
    };

    return {
      ...map,
      ..._.pickBy(_.pick(supplierAgent, _.keys(map)), _.negate(_.isNil)),
    };
  },

  validationSchema: yup.object({}).shape({
    name: validatinShemas.vNameReq,
    phone: validatinShemas.vPhoneReq,
    email: validatinShemas.vEmailReq,
  }),

  handleSubmit: (
    values,
    {
      props: {
        ownerId,
        updateSupplierAgentReq,
        supplierAgent: { id },
      },
      setSubmitting,
    }
  ) => {
    updateSupplierAgentReq({ values, ownerId, id });
  },
  displayName: 'LoginForm',
});

export default compose<OtherProps & FormikProps<FormValues>, {}>(
  connect(
    {},
    { updateSupplierAgentReq }
  ),
  exchangeFormic
)(EditForm);

const style = {
  description: css`
    font-size: 12px;
    color: ${Colors.LightBlack};
    margin: 5px;
  `,
};
